// extracted by mini-css-extract-plugin
module.exports = {"Clients":"clients_Clients__1e3wD","Search":"clients_Search__pYZZV","Query":"clients_Query__kZu1Z","Headers":"clients_Headers__p7dBP","ListContainer":"clients_ListContainer__1aQlL"};